import React from 'react';
import Questions from "./components/Questions";

const App = (data, questionnaireId) => {

    return (
        <div className="app">
            <Questions data={data} questionnaireId={questionnaireId} />
        </div>
    );
}

export default App;
